import { useEffect, useState } from "react";
import api from "../lib/api";
import { AlarmClock } from "lucide-react";

const BUCKETS = [
  { key: "current", label: "On time", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { key: "d7", label: "≤7d late", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  { key: "d14", label: "8–30d late", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  { key: "d30", label: "30d+ late", cls: "bg-rose-50 text-rose-700 border-rose-200" },
];

export const ActionsBoard = ({ onPickHotel }) => {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/actions/board").then((r) => setData(r.data)); }, []);

  if (!data) return <p className="py-10 text-center text-sm text-stone-400">Loading board...</p>;
  if (data.hotels.length === 0) return <p className="py-10 text-center text-sm text-stone-400" data-testid="board-empty">No open corrective actions — all clear.</p>;

  return (
    <div className="space-y-3" data-testid="actions-board">
      <p className="text-sm text-stone-500">
        <b className="text-stone-800">{data.totals.open}</b> open actions across <b className="text-stone-800">{data.hotels.length}</b> hotels — <b className="text-rose-600">{data.totals.overdue} overdue</b>. Sorted by worst aging first; click a hotel to see its actions.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {data.hotels.map((h) => (
          <button key={h.hotel_id} data-testid={`board-hotel-${h.hotel_id}`}
            className="text-left bg-white border border-[#E7E5DF] rounded-xl p-4 hover:border-[#14532D]/40 hover:shadow-sm transition-colors"
            onClick={() => onPickHotel(h.hotel_name)}>
            <div className="flex items-start justify-between gap-2">
              <p className="text-sm font-semibold text-stone-800 leading-snug">{h.hotel_name}</p>
              <span className="shrink-0 text-lg font-extrabold text-[#14532D] font-mono">{h.open}</span>
            </div>
            <div className="flex flex-wrap gap-1.5 mt-3">
              {BUCKETS.map((b) => h[b.key] > 0 && (
                <span key={b.key} className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-bold border ${b.cls}`}>{h[b.key]} {b.label}</span>
              ))}
              {h.awaiting_review > 0 && <span className="inline-flex px-1.5 py-0.5 rounded text-[10px] font-bold border bg-violet-50 text-violet-700 border-violet-200">{h.awaiting_review} to review</span>}
            </div>
            <div className="flex items-center justify-between mt-3 text-[11px] text-stone-400">
              <span className="truncate">{h.departments.map(([d, n]) => `${d} (${n})`).join(" · ")}</span>
              {h.oldest_days > 0 && <span className="inline-flex items-center gap-1 text-rose-600 font-semibold shrink-0 ml-2"><AlarmClock className="w-3 h-3" />{h.oldest_days}d</span>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
